export const LABEL_CLASSNAME =
  'normal-case text-[13px] text-text-blue tracking-normal leading-4 font-bold';

export const FIELD_NAMES = {
  interactionId: 'interactionId',
  codeConceptId: 'codeConceptId',
  periodType: 'periodType',
  singleDate: 'singleDate',
  rangeStart: 'rangeStart',
  rangeEnd: 'rangeEnd',
  hours: 'hours',
  minutes: 'minutes',
  note: 'note',
};

export const COMMUNITY_ENGAGEMENT_INTERACTION_CODE = 'documentation-medicaid-engagement';

export const ENTERED_IN_ERROR_STATE_CODE = 'entered-in-error';

export const VALUE_SET_COMPUTABLE_NAMES = {
  community_engagement_procedures: 'community_engagement_procedure_codes',
  community_engagement: 'community_engagement_interaction_types',
  interactionState: 'community_engagement_interaction_states',
  interactionClass: 'community_engagement_interaction_classes',
  procedureState: 'community_engagement_procedure_states',
  procedureUnit: 'community_engagement_procedure_units',
};

export const PERIOD_TYPE = {
  SINGLE: 'single',
  RANGE: 'range',
};

export const PERIOD_OF_SERVICE_OPTIONS = [
  { label: 'Single Date', value: PERIOD_TYPE.SINGLE },
  { label: 'Date Range', value: PERIOD_TYPE.RANGE },
];

export const MINUTE_OPTIONS = [0, 15, 30, 45].map((n) => ({
  value: String(n),
  label: String(n),
}));
